import { useQuery, useQueryClient } from "@tanstack/react-query";

import { supabase } from "@/shared/lib/supabase";

function buildQueryKey(estateId: number | undefined) {
  return ["hasDeathCert", estateId] as const;
}

export function useHasDeathCert(estateId: number | undefined) {
  const queryClient = useQueryClient();

  const { data: hasDeathCert = null } = useQuery({
    queryKey: buildQueryKey(estateId),
    queryFn: async () => {
      const { data } = await supabase
        .from("estate_documents")
        .select("id")
        .eq("estate_id", estateId!)
        .eq("document_type", "death_certificate")
        .limit(1);

      return !!data && data.length > 0;
    },
    enabled: !!estateId,
  });

  const setHasDeathCert = () => {
    queryClient.setQueryData(buildQueryKey(estateId), true);
  };

  return { hasDeathCert, setHasDeathCert };
}
